<template>
  <div>
    <div class="loading" v-if="loading">
      <!-- <span>
        <b-spinner big class="m-4" label="Loading..."></b-spinner>
      </span>-->
    </div>
    <b-form class="formContainer" @submit.prevent="onSubmit" v-else>
      <h3>Edycja ustawień makrocyklu kursanta</h3>
      <hr />
      <b-form-group>
        <b-form-checkbox
          switch
          v-model="isActive"
          @change="$v.$reset()"
        >Generowanie makrocyklu aktywne</b-form-checkbox>
      </b-form-group>

      <b-form-group class="required" label="Dzień wolny" v-if="isActive">
        <b-form-select
          v-model="freeDay"
          :options="freeDaysOptions"
          :state="$v.freeDay.$error? false : null"
        ></b-form-select>
        <b-form-invalid-feedback>
          <div v-if="!$v.freeDay.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group class="required" label="Rozpoczęcie" v-if="isActive">
        <date-picker
          :class="{'is-invalid': $v.startsAt.$error}"
          v-model="startsAt"
          :config="dateTimeOptions"
          autocomplete="off"
          language="pl"
        />
        <div class="invalid-feedback" v-if="!$v.startsAt.required">To pole jest wymagane</div>
      </b-form-group>

      <b-form-group class="text-right">
        <hr />
        <b-button
          v-b-modal.saveConfirm
          class="pull-right"
          type="button"
          variant="primary"
        >
          Zapisz
        </b-button>

        <b-modal id="saveConfirm" title="Zapisz">
          <b-container style="text-align: left;">
            Czy na pewno chcesz zapisać ustawienia makrocyklu kursanta?
          </b-container>
        
          <template slot="modal-footer">
            <b-container>
              <b-row>
                <b-col style="text-align: right; padding-right: 0px;">
                  <b-button variant="secondary" @click="$bvModal.hide('saveConfirm')" style="margin-right: 4px;">Anuluj</b-button>
                  <b-button variant="primary" :disabled="saving" @click="onSubmit()">
                    <span v-show="!saving">Zapisz</span>
                    <span v-show="saving">
                      <b-spinner small label="Proszę czekać..."></b-spinner>
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </template>
        </b-modal>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      saving: false,
      loading: false,
      isActive: false,
      freeDay: null,
      startsAt: null,
      dateTimeOptions: {
        format: "YYYY-MM-DD",
        locale: "pl"
      },
      freeDaysOptions: [
        { value: null, text: "..." },
        { value: 1, text: "Poniedziałek" },
        { value: 2, text: "Wtorek" },
        { value: 3, text: "Środa" },
        { value: 4, text: "Czwartek" },
        { value: 5, text: "Piątek" },
        { value: 6, text: "Sobota" }
      ]
    };
  },
  props: ["id"],
  validations() {
    if (this.isActive) {
      return { startsAt: { required }, freeDay: { required } };
    } else return {};
  },

  mounted() {
    if (this.id) {
      this.loading = true;
      axios
        .get("/students/edit", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data.cycleSettings;
          this.isActive = result.isActive;
          this.freeDay = result.freeDay;
          this.startsAt = result.startDate;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    onSubmit() {
      if (!this.$v.$error) {
        this.saving = true;

        if (!this.isActive) {
          this.startsAt = null;
          this.freeDay = null;
        }

        axios
          .put("/students/cycleSettings", {
            userId: this.id,
            isActive: this.isActive,
            startsAt: this.startsAt,
            freeDay: this.freeDay
          })
          .then(response => {
            window.console.log(response.data);
            eventBus.$emit("notify-success", "Zapisano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => {
            this.saving = false;
            this.$bvModal.hide('saveConfirm');
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

